var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.922 32.484h.002l12.235-.044v25.913H12.922a.314.314 0 0 1-.317-.317V32.801c0-.15.157-.317.317-.317zm32.924 25.87V32.438h12.1c.179 0 .318.139.318.317v25.28c0 .16-.167.317-.317.317h-12.1z",
    fill: "#D9D9D9",
    stroke: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.818 43.285h-5.401a.314.314 0 0 1-.317-.317v-5.401c0-.15.156-.317.317-.317h5.4c.042 0 .126.026.209.109.083.083.109.166.109.208v5.446c0 .036-.02.103-.095.172a.35.35 0 0 1-.222.1zM21.818 53.497h-5.401a.314.314 0 0 1-.317-.317v-5.446c0-.178.139-.317.317-.317h5.4c.151 0 .318.157.318.317v5.4c0 .224-.185.363-.317.363zM54.36 43.285h-5.4a.314.314 0 0 1-.317-.317v-5.401c0-.15.156-.317.317-.317h5.4c.16 0 .318.167.318.317v5.446c0 .114-.12.272-.317.272zM54.36 53.497h-5.4a.314.314 0 0 1-.317-.317v-5.446c0-.178.139-.317.317-.317h5.4c.178 0 .318.139.318.317v5.4c0 .242-.157.363-.317.363z",
    fill: "#E8E8E8",
    stroke: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.434 17.686a.314.314 0 0 1-.317-.317V8.473c0-.178.14-.317.317-.317.178 0 .317.14.317.317v8.942c0 .114-.12.271-.317.271z",
    fill: "#2D344B",
    stroke: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.373 13.647v.025l.003.025c.013.13-.086.267-.274.267h-9.668a.314.314 0 0 1-.317-.317V8.473c0-.178.14-.317.317-.317h9.622c.178 0 .317.14.317.317v5.174zM35.301 17.06l.003-.001a.253.253 0 0 1 .307 0l.003.002 10.212 6.717.009.006.009.005c.055.033.12.13.12.252v33.94a.65.65 0 0 1-.15.288c-.064.066-.12.084-.167.084H25.268a.314.314 0 0 1-.317-.317V24.041c0-.079.031-.17.16-.277L35.3 17.06z",
    fill: "#8B8B8B",
    stroke: "#383838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.986 62.938H8.973a.314.314 0 0 1-.317-.317v-4.584c0-.178.14-.317.317-.317h53.013c.178 0 .317.139.317.317v4.584c0 .177-.14.317-.317.317z",
    fill: "#8B8B8B",
    stroke: "#383838"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.698 57.9h-10.53a.314.314 0 0 1-.316-.317V40.608c0-.178.139-.317.317-.317h10.53c.177 0 .316.139.316.317v16.988c-.03.192-.171.304-.317.304z",
    fill: "#EFEFF0",
    stroke: "#383838"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.434 57.9a.314.314 0 0 1-.317-.317V40.608c0-.178.14-.317.317-.317.178 0 .317.139.317.317v17.02c0 .114-.12.272-.317.272z",
    fill: "#2D344B",
    stroke: "#383838"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.666 28.881c0-2.126 1.688-3.857 3.796-3.857a3.874 3.874 0 0 1 3.857 3.857 3.874 3.874 0 0 1-3.857 3.857c-2.051 0-3.796-1.735-3.796-3.857z",
    fill: "#DFE1E7",
    stroke: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolDefaultIcon);
export default __webpack_public_path__ + "static/media/school_default_icon.f666ac41273f645e79736c269edbc570.svg";
export { ForwardRef as ReactComponent };